import { useQuery } from "@tanstack/react-query";
import { fetchWorkspaceDetail } from "../services/workspaces/workspacesApi";
import { mapWorkspace } from "../services/workspaces/workspacesMappers";
import { queryKeys } from "../services/queryKeys";
import type { Workspace } from "../services/workspaces/workspaces.types";

export interface UseWorkspaceDetailResult {
  workspace: Workspace | null;
  isLoading: boolean;
  isError: boolean;
}

export const useWorkspaceDetail = (
  workspaceId: string | undefined,
  options: { enabled?: boolean } = {},
): UseWorkspaceDetailResult => {
  const { data, isLoading, isError } = useQuery({
    queryKey: queryKeys.workspaces.detail(workspaceId ?? ""),
    queryFn: () => fetchWorkspaceDetail(workspaceId!),
    enabled: !!workspaceId && (options.enabled ?? true),
    select: mapWorkspace,
    retry: false,
  });
  return {
    workspace: data ?? null,
    isLoading,
    isError,
  };
};
